<header class="topbar">

    <!-- LOGO -->
    <a routerLink="/" class="logo"></a>


    <!-- DESKTOP NAV -->
    <nav class="desktop-nav">

        <a
            routerLink="/"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">

            Početna

        </a>

            <a
            href="/"
            (click)="goToCatalog($event)">

            <span class="menu-icon">
                <i class="bi bi-book"></i>
            </span>

            <span class="menu-text">
                Katalog
            </span>

        </a>

        <a
            routerLink="/gallery"
            routerLinkActive="active">

            Galerija

        </a>

        <a
            routerLink="/contact"
            routerLinkActive="active">

            Kontakt

        </a>

    </nav>


    <a
    href="https://drive.google.com/file/d/1U1ofbswTDA5GMuUCUmn_Y5TDSUThXR7r/view"
    class="btn-main"
    target="_blank"
    rel="noopener">

    Preuzmi katalog

    </a>

</header>


<!-- =========================================
     MOBILE MENU BUTTON
========================================= -->

<button
    class="menu-toggle"
    [class.open]="menuOpen"
    (click)="menuOpen = !menuOpen"
    aria-label="Otvori meni">

    <span></span>
    <span></span>
    <span></span>

</button>


<!-- =========================================
     MOBILE MENU
========================================= -->

<div
    class="mobile-menu"
    [class.open]="menuOpen">


    <!-- BLOB -->
    <svg
        class="menu-blob"
        viewBox="0 0 330 900"
        preserveAspectRatio="none">

        <defs>

            <filter
                id="blueGlow"
                x="-50%"
                y="-50%"
                width="200%"
                height="200%">

                <feGaussianBlur
                    stdDeviation="4"
                    result="blur">
                </feGaussianBlur>

                <feMerge>

                    <feMergeNode in="blur"></feMergeNode>

                    <feMergeNode in="SourceGraphic"></feMergeNode>

                </feMerge>

            </filter>

        </defs>


        <!-- MAIN DARK BLOB -->

        <path
            class="blob-background"
            d="
                M0 0
                H270

                C315 110,
                315 210,
                285 300

                C255 390,
                255 470,
                285 560

                C315 650,
                315 760,
                270 900

                H0
                Z
            ">
        </path>


        <!-- BLUE BORDER -->

        <path
            class="blob-border"
            d="
                M270 0

                C315 110,
                315 210,
                285 300

                C255 390,
                255 470,
                285 560

                C315 650,
                315 760,
                270 900
            ">
        </path>

    </svg>


    <!-- =====================================
         MENU CONTENT
    ====================================== -->

    <div class="mobile-menu-content">


        <!-- LOGO -->
        <a
            routerLink="/"
            class="mobile-logo"
            (click)="menuOpen = false">            
        </a>


        <!-- LINKS -->

        <nav class="mobile-links">


            <!-- HOME -->

            <a
                routerLink="/"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="menuOpen = false">

                <span class="menu-icon">

                    <i class="bi bi-house"></i>

                </span>

                <span class="menu-text">
                    Početna
                </span>

            </a>


            <!-- CATALOG -->

                <a
                    href="/"
                    (click)="goToCatalog($event)">

                    <span class="menu-icon">
                        <i class="bi bi-book"></i>
                    </span>

                    <span class="menu-text">
                        Katalog
                    </span>

                </a> 



            <!-- GALLERY -->

            <a
                routerLink="/gallery"
                routerLinkActive="active"
                (click)="menuOpen = false">

                <span class="menu-icon">

                    <i class="bi bi-images"></i>

                </span>

                <span class="menu-text">
                    Galerija
                </span>

            </a>


            <!-- CONTACT -->

            <a
                routerLink="/contact"
                routerLinkActive="active"
                (click)="menuOpen = false">

                <span class="menu-icon">

                    <i class="bi bi-envelope"></i>

                </span>

                <span class="menu-text">
                    Kontakt
                </span>

            </a>

        </nav>


        <!-- DIVIDER -->

        <div class="menu-divider"></div>


        <!-- DOWNLOAD -->

                    <button
                type="button"
                class="download-button"
                (click)="testDownload()">              
       
                <span class="menu-text">
                    PREUZMI KATALOG
                </span>

            </button>
        </div>

</div>


<!-- =========================================
     OVERLAY
========================================= -->

<div
    class="menu-overlay"
    *ngIf="menuOpen"
    (click)="menuOpen = false">
</div>